export const REGISTER = "REGISTER";
export const TOGGLE_LOADING = "TOGGLE_LOADING";
